// extracted by mini-css-extract-plugin
export var active = "itempreview-module--active--9HKfN";
export var button = "itempreview-module--button--erRFd";
export var disabled = "itempreview-module--disabled--mGFDg";
export var label = "itempreview-module--label--dLVEH";
export var mobilemargin = "itempreview-module--mobilemargin--9LVCt";
export var wrapper = "itempreview-module--wrapper--fPX-m";